<template>
  <div class="message-detail-page">
    <SubPageHeader title="消息详情" />
    
    <div class="content-wrap" v-if="message">
      <div class="msg-title">{{ message.title || '消息通知' }}</div>
      <div class="msg-time">{{ message.create_time || message.meeting_time || message.time || message.created_at || '--' }}</div>
      
      <div class="msg-content" v-if="message.content && message.content.length">
        <p v-for="(line, idx) in message.content" :key="idx">{{ line }}</p>
      </div>
      <div class="msg-content" v-else-if="message.topic || message.meeting_topic">
        <p>消息主题：{{ message.topic || message.meeting_topic }}</p>
      </div>
    </div>
    
    <div class="empty-state" v-else>
      <div class="state-text">未获取到消息详情</div>
    </div>
  </div>
</template>

<script>
import SubPageHeader from '../component/SubPageHeader.vue'

export default {
  name: 'MessageDetailPage',
  components: {
    SubPageHeader
  },
  data() {
    return {
      message: null
    }
  },
  mounted() {
    try {
      // 从 sessionStorage 中读取传递过来的消息数据
      const data = sessionStorage.getItem('currentMessageDetail')
      if (data) {
        this.message = JSON.parse(data)
      }
    } catch (e) {
      console.error('Failed to parse message detail', e)
    }
  }
}
</script>

<style lang="scss" scoped>
.message-detail-page {
  min-height: 100vh;
  background-color: #fff;
  display: flex;
  flex-direction: column;
}

.content-wrap {
  padding: 5vw;
}

.msg-title {
  font-size: 5.5vw;
  font-weight: bold;
  color: #333;
  line-height: 1.4;
  margin-bottom: 3vw;
}

.msg-time {
  font-size: 3.5vw;
  color: #999;
  margin-bottom: 5vw;
  border-bottom: 1px solid #f0f0f0;
  padding-bottom: 4vw;
}

.msg-content {
  font-size: 4.2vw;
  color: #444;
  line-height: 1.8;
  
  p {
    margin: 0 0 2.5vw 0;
    word-break: break-all;
  }
}

.empty-state {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  
  .state-text {
    color: #999;
    font-size: 4vw;
  }
}
</style>
